import { formatDate } from '../helpers/common';
import Base, { baseInit } from './base';

class Location extends Base {
  locationId = null; // Integer
  addresses = null; // [String]

  constructor(data) {
    super(data);
    baseInit(this, data);
    if (!this.addresses) {
      this.addresses = [];
    }
  }
}

class Campaign extends Base {
  id = null; // Integer
  industryId = null; // Integer
  location = null; // Location
  marketingObjectiveId = null; // Integer

  advertiserName = null;
  agencyName = null;
  budget = null; // Integer
  campaignName = null;
  flightStartDate = null; // Date: '2019-04-09T18:37:40.639Z';
  flightEndDate = null; // Date: '2019-04-09T18:37:40.639Z';

  updatedCampaign = false;

  constructor(data) {
    super(data);
    baseInit(this, data);
    if (this.location) {
      this.location = new Location(this.location);
    }
    if (this.flightStartDate) {
      this.flightStartDate = formatDate(this.flightStartDate).toDate();
    }
    if (this.flightEndDate) {
      this.flightEndDate = formatDate(this.flightEndDate).toDate();
    }
  }
}

export { Location, Campaign };
